export const globalStyles = `
  .js-focus-visible :focus:not([data-focus-visible-added]) {
    outline: none;
    boxShadow: none;
  }
`;
